module.exports = __webpack_public_path__ + "static/media/plus-sign-white.343d231d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/plus-sign-white.svg
// module id = 857
// module chunks = 0